import React, { useState, useEffect, useCallback } from 'react';
import { RefreshCw, ShieldCheck, ShieldAlert } from 'lucide-react';
import apiService from '../../../apiService';
import { fmtMoney, fmtInt, Card, Spinner, SEVERITY_META } from '../financeShared';

export default function AntiFraudTab({ currency, rate }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState({});
  const fmt = (n) => fmtMoney(n, currency, rate);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiService.get('/admin/finance/fraud-signals', { userType: 'admin' });
      if (res?.success) setData(res);
    } catch (e) { console.error('fraud-signals:', e); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const signals = data?.signals || [];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <div>
          {data && (data.alerts > 0
            ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#dc2626', fontWeight: 700 }}><ShieldAlert size={18} /> {data.alerts} signal(aux) d'alerte</span>
            : <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#10B981', fontWeight: 700 }}><ShieldCheck size={18} /> Aucun signal suspect</span>)}
        </div>
        <button className="btn-secondary" onClick={load} style={{ padding: '0.4rem 1rem', display: 'flex', alignItems: 'center', gap: 6 }}><RefreshCw size={15} /> Actualiser</button>
      </div>

      <div style={{ background: '#F4F5F7', borderRadius: '10px', padding: '0.85rem 1rem', marginBottom: '1.5rem', color: '#414852', fontSize: '0.82rem' }}>
        Détection heuristique d'anomalies financières (retraits rapprochés, commissions impayées, remboursements élevés…). Ces signaux sont des pistes à vérifier, pas des preuves de fraude.
      </div>

      {loading ? <Spinner /> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.9rem' }}>
          {signals.map(s => {
            const sev = SEVERITY_META[s.count > 0 ? s.severity : 'ok'];
            const isOpen = open[s.key];
            return (
              <Card key={s.key} style={{ padding: '1rem 1.25rem', borderLeft: `4px solid ${sev.color}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: s.count > 0 ? 'pointer' : 'default' }}
                  onClick={() => s.count > 0 && setOpen(o => ({ ...o, [s.key]: !o[s.key] }))}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: '0.7rem', padding: '0.2rem 0.55rem', borderRadius: '10px', background: sev.bg, color: sev.color, fontWeight: 700 }}>{sev.label}</span>
                    <span style={{ fontWeight: 600, color: '#1E2229' }}>{s.label}</span>
                  </div>
                  <span style={{ fontWeight: 700, color: s.count > 0 ? sev.color : '#10B981', fontSize: '1.1rem' }}>{fmtInt(s.count)}</span>
                </div>
                {isOpen && s.sample?.length > 0 && (
                  <div style={{ marginTop: '0.9rem', overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                      <thead><tr style={{ borderBottom: '1px solid #E9EBEF', color: '#9AA0A8' }}>
                        <th style={{ textAlign: 'left', padding: '0.4rem' }}>Référence</th>
                        <th style={{ textAlign: 'left', padding: '0.4rem' }}>Type</th>
                        <th style={{ textAlign: 'right', padding: '0.4rem' }}>Occurrences</th>
                        <th style={{ textAlign: 'right', padding: '0.4rem' }}>Montant</th>
                      </tr></thead>
                      <tbody>
                        {s.sample.map((row, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid #F4F5F7' }}>
                            <td style={{ padding: '0.4rem', fontFamily: 'monospace', color: '#414852' }}>{row.id}</td>
                            <td style={{ padding: '0.4rem', color: '#5C636E' }}>{row.type || '—'}</td>
                            <td style={{ padding: '0.4rem', textAlign: 'right', color: '#1E2229' }}>{row.count != null ? fmtInt(row.count) : '—'}</td>
                            <td style={{ padding: '0.4rem', textAlign: 'right', fontWeight: 600, color: '#1E2229' }}>{row.amount != null ? fmt(row.amount) : '—'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      )}
    </>
  );
}
